import React from 'react';

export default function AddAdmin() {
  return (
    <div>
      <p>Steps to Add an Admin</p>
      <p><strong>Step 1: Access Admin Management</strong></p>
      <ol>
        <li>Navigate to the Admins section in the main dashboard.</li>
        <li>Click on the Add Admin button to open the admin registration form.</li>
      </ol>
      <p><strong>Step 2: Enter Admin Details</strong></p>
      <ul>
        <li>
          <strong>First Name:</strong>
          <ul>
            <li>Enter the admin’s first name.</li>
            <li>Example: John</li>
          </ul>
        </li>
        <li>
          <strong>Last Name:</strong>
          <ul>
            <li>Enter the admin’s last name.</li>
            <li>Example: Doe</li>
          </ul>
        </li>
        <li>
          <strong>E-Mail:</strong>
          <ul>
            <li>Provide a valid email address.</li>
            <li>Example: johndoe@example.com</li>
          </ul>
        </li>
        <li>
          <strong>Password:</strong>
          <ul>
            <li>Set a strong password for the admin account.</li>
            <li>Example: P@ssw0rd123</li>
          </ul>
        </li>
      </ul>

      <img
        src="  https://res.cloudinary.com/danfpnuui/image/upload/v1737795966/WhatsApp_Image_2025-01-25_at_1.40.55_PM_d0us3x.jpg"
        alt="Import Resume"
        className="placeholder-image image_gatnix_support"
      />

      <p><strong>Step 3: Add Contact Information</strong></p>
      <ul>
        <li>
          <strong>Mobile Number:</strong>
          <ul>
            <li>Enter the admin’s mobile number with the country code.</li>
            <li>Example: +1 555-123-4567</li>
          </ul>
        </li>
        <li>
          <strong>WhatsApp Number:</strong>
          <ul>
            <li>If the WhatsApp number is the same as the mobile number, check the Same As Mobile Number box.</li>
            <li>Otherwise, manually enter the WhatsApp number.</li>
          </ul>
        </li>
      </ul>

      {/* <img
        src="    "
        alt="Import Resume"
        className="placeholder-image image_gatnix_support"
      /> */}


      <p><strong>Step 4: Save the Admin</strong></p>
      <ol>
        <li>Review all entered details for accuracy.</li>
        <li>Click Save to add the new admin.</li>
      </ol>
      <p><strong>Optional: Cancel</strong></p>
      <ul>
        <li>If you do not wish to proceed, click Cancel to exit without saving changes.</li>
      </ul>
      <p><strong>Confirmation</strong></p>
      <p>
        After saving, a message will appear: <em>“Admin successfully added.”</em>
      </p>
    </div>
  );
}

